import {
  CallableInput,
  CallableToggle,
  CountrySelect,
} from "Components/Shared";
import FormSubmit from "Components/Shared/FormSubmit";
import OutboundProxyType from "Components/Shared/OutboundProxyType";
import { Field, Formik } from "formik";
import { useVoiceRegion } from "Hooks/Endpoints";
import React from "react";
import { Form } from "semantic-ui-react";

const OutboundProxyCreateForm = () => {
  const { createOutboundProxy, saveOutboundProxy, uncreateOutboundProxy } =
    useVoiceRegion();
  return (
    <Formik
      validateOnChange={false}
      initialValues={createOutboundProxy}
      enableReinitialize={true}
      onSubmit={(values, actions) => {
        saveOutboundProxy(values);
      }}
    >
      {({ handleSubmit, errors, validateField, values }) => (
        <Form onSubmit={handleSubmit}>
          <Field name='ip' label='IP' component={CallableInput} />

          <Field name='port' label='port' component={CallableInput} />

          <Field
            name='description'
            label='Description'
            component={CallableInput}
          />

          <OutboundProxyType name='type' label='Proxy Type' />

          <Field name='zone' label='zone' component={CallableInput} />

          <Field
            name='priority'
            label='Priority'
            type='number'
            component={CallableInput}
          />

          <CountrySelect name='countryCode' label='Country Code' />

          <Field
            name='inbound'
            label='Inbound'
            toggle
            component={CallableToggle}
          />

          <Field
            name='outbound'
            label='Outbound'
            toggle
            component={CallableToggle}
          />

          <Field
            name='active'
            label='Active'
            toggle
            component={CallableToggle}
          />

          <FormSubmit
            name='Create'
            errors={errors}
            onCancel={() => uncreateOutboundProxy()}
          />
        </Form>
      )}
    </Formik>
  );
};

export default OutboundProxyCreateForm;
